function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import range from 'lodash/range';
import round from 'lodash/round';
import get from 'lodash/get';
import withStyles from 'isomorphic-style-loader/withStyles';
import Draggable from 'react-draggable';
import AutoSizer from 'react-virtualized-auto-sizer';
import slidersStyles from '../Sliders.pcss';
import messages from '../../../modules/Patient/messages';
import styles from './GlucoseLevelsSlider.pcss';
var _React_PureComponent;
class GlucoseLevelsSlider extends (_React_PureComponent = React.PureComponent) {
    countValue(data, height) {
        const { valueMax, valueMin, valueDragStep, precision } = this.props;
        const offset = (height - data.y) / height * (valueMax - valueMin);
        return round(offset, precision) - round(offset, precision) % valueDragStep;
    }
    renderScaleValue() {
        const { valueMax, valueMin, valueStep } = this.props;
        return range(valueMin, valueMax + 1, valueStep).map((value)=>/*#__PURE__*/ _jsx("div", {
                className: "scaleValue__value brand__caption",
                children: value
            }, value));
    }
    // renderScaleGrid() {
    //   const { valueMax, valueMin, valueStep } = this.props;
    //   return range(valueMin, valueMax + 1, valueStep).map(
    //     (value) => (<div className="scaleGrid__row" key={value} />),
    //   );
    // }
    renderScales() {
        return /*#__PURE__*/ _jsx("div", {
            className: "scaleValue scaleValue--left",
            children: this.renderScaleValue()
        });
    }
    renderRangeSliderHandler({ level, height, top }) {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('rangeSlider', {
                'rangeSlider--top': level === this.levels.HIGH,
                'rangeSlider--bottom': level === this.levels.LOW
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rangeSlider__area",
                    style: {
                        height: `${height}px`,
                        top: top && `${top}px`
                    }
                }),
                /*#__PURE__*/ _jsx("button", {
                    className: cn('rangeSlider__dragButton', 'rangeSlider__dragButton--end'),
                    type: "button"
                })
            ]
        });
    }
    renderSlider(top, value, type) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "brand__caption rangeSlider__overlay",
                    style: {
                        top
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(slidersStyles.rengeSlider__value, {
                        [slidersStyles.rangeSlider__high]: type === 'high',
                        [slidersStyles.rangeSlider__low]: type === 'low'
                    }),
                    style: {
                        top
                    },
                    children: value
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn('brand__caption', slidersStyles.rengeSlider__label),
                    style: {
                        top
                    },
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[type]))
                })
            ]
        });
    }
    renderRangeSliders(height) {
        const { valueMax, valueMin, formValues, locked, targetType } = this.props;
        const countOffset = (value = 0)=>height - value / (valueMax - valueMin) * height;
        const values = {
            glucoseHigh: get(formValues, `values.${targetType}_highThreshold`),
            glucoseLow: get(formValues, `values.${targetType}_lowThreshold`)
        };
        const offsets = {
            glucoseHigh: countOffset(values.glucoseHigh),
            glucoseLow: countOffset(values.glucoseLow)
        };
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rangeSegment",
                    style: {
                        right: 0
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "rangeSegmentBorder",
                        children: [
                            /*#__PURE__*/ _jsx(Draggable, {
                                axis: "y",
                                disabled: locked,
                                position: {
                                    y: offsets.glucoseHigh,
                                    x: 0
                                },
                                onDrag: (e, data)=>{
                                    this.props.onRangeChange({
                                        id: `${targetType}_highThreshold`,
                                        value: this.countValue(data, height)
                                    });
                                },
                                bounds: {
                                    top: 20,
                                    bottom: offsets.glucoseLow
                                },
                                children: this.renderRangeSliderHandler({
                                    level: this.levels.HIGH,
                                    height: offsets.glucoseHigh,
                                    value: values.glucoseHigh
                                })
                            }),
                            /*#__PURE__*/ _jsx(Draggable, {
                                axis: "y",
                                disabled: locked,
                                position: {
                                    y: offsets.glucoseLow,
                                    x: 0
                                },
                                onDrag: (e, data)=>{
                                    this.props.onRangeChange({
                                        id: `${targetType}_lowThreshold`,
                                        value: this.countValue(data, height)
                                    });
                                },
                                bounds: {
                                    top: offsets.glucoseHigh,
                                    bottom: height - 20
                                },
                                children: this.renderRangeSliderHandler({
                                    level: this.levels.LOW,
                                    height: height - offsets.glucoseLow,
                                    value: values.glucoseLow
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "targetArea",
                                style: {
                                    top: `${offsets.glucoseHigh}px`,
                                    bottom: `${height - offsets.glucoseLow}px`
                                }
                            })
                        ]
                    })
                }),
                this.renderSlider(offsets.glucoseHigh, values.glucoseHigh, 'high'),
                this.renderSlider(offsets.glucoseLow, values.glucoseLow, 'low')
            ]
        });
    }
    renderSlidersLayer() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('sliders', {
                'sliders--locked': this.props.locked
            }),
            children: /*#__PURE__*/ _jsx(AutoSizer, {
                children: ({ height, width })=>/*#__PURE__*/ _jsx("div", {
                        style: {
                            width: `${width}px`,
                            height: `${height}px`
                        },
                        children: this.renderRangeSliders(height)
                    })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(slidersStyles.rangesSlider, styles.patientRangesSlider),
            children: [
                this.renderScales(),
                this.renderSlidersLayer()
            ]
        });
    }
    constructor(props){
        super(props);
        this.levels = {
            LOW: 'low',
            TARGET: 'target',
            HIGH: 'high'
        };
        this.state = {};
    }
}
_define_property(GlucoseLevelsSlider, "propTypes", {
    // Explicit props
    valueMin: PropTypes.number,
    valueMax: PropTypes.number,
    valueStep: PropTypes.number,
    valueDragStep: PropTypes.number,
    formValues: PropTypes.object,
    conversion: PropTypes.object,
    locked: PropTypes.bool,
    targetType: PropTypes.string,
    precision: PropTypes.number,
    phiSet: PropTypes.object,
    // Explicit actions
    onRangeChange: PropTypes.func
});
_define_property(GlucoseLevelsSlider, "defaultProps", {
    valueMin: 0,
    valueMax: 300,
    valueStep: 50,
    valueDragStep: 1,
    locked: false,
    targetType: '',
    precision: 0
});
export default withStyles(styles, slidersStyles)(GlucoseLevelsSlider);
